import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function companyBusinessInquiry(token, params) {

    return Api.put(REQUEST_URLS.COMPANY_APPROVAL.CONFIRM_BUSINESS, params, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default companyBusinessInquiry;